import { CreateEmergencyContactFormModel } from '@/views/emergencyContacts/create/model/CreateEmergencyContactForm.model.ts';

export type EmergencyContactsCreateTranslation = {
  button: {
    cancel: string;
    save: string;
  };
  form: Record<keyof CreateEmergencyContactFormModel, string>;
  title: {
    create: string;
    update: string;
  };
};

export const emergencyContactsCreateTranslation: EmergencyContactsCreateTranslation = {
  button: {
    cancel: 'Anuluj',
    save: 'Zapisz',
  },
  form: {
    category: 'Kategoria',
    description: 'Opis',
    email: 'Email',
    name: 'Nazwa',
    phoneNumber: 'Numer telefonu',
    status: 'Status',
  },
  title: {
    create: 'Dodaj kontakt alarmowy',
    update: 'Edytuj kontakt alarmowy',
  },
};
